export default "__VITE_ASSET__D2hH8uFm__"